function ProgrammeSuccessModal({
  isOpen,
  programme,
  appTheme,
  isMobile,
  onChooseNew,
  onBackToManual
}) {
  if (!isOpen || !programme) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(15,23,42,0.55)",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        zIndex: 3000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px"
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "480px",
          borderRadius: "28px",
          background: appTheme.modalBackground,
          border: appTheme.cardBorder,
          boxShadow: "0 24px 80px rgba(15,23,42,0.22)",
          padding: isMobile ? "28px 22px" : "36px 30px",
          textAlign: "center"
        }}
      >
        {/* Trophy */}
        <div style={{
          fontSize: "52px",
          marginBottom: "16px",
          lineHeight: 1
        }}>
          🏆
        </div>

        {/* Title */}
        <div style={{
          fontSize: isMobile ? "22px" : "26px",
          fontWeight: "500",
          fontFamily: appTheme.fontHeading,
          color: appTheme.primaryText,
          marginBottom: "10px",
          lineHeight: 1.15
        }}>
          You finished it!
        </div>

        {/* Programme name */}
        <div style={{
          fontSize: isMobile ? "16px" : "18px",
          fontWeight: "500",
          fontFamily: appTheme.fontHeading,
          color: appTheme.accentColor,
          marginBottom: "12px"
        }}>
          {programme.name}
        </div>

        {/* Message */}
        <div style={{
          fontSize: "14px",
          color: appTheme.secondaryText,
          lineHeight: 1.6,
          marginBottom: "28px"
        }}>
          Brilliant work completing the full programme. This has been saved to your Trophy Room in Profile.
        </div>

        {/* Stats pill */}
        <div style={{
          display: "inline-flex",
          gap: "16px",
          padding: "12px 20px",
          borderRadius: "16px",
          background: appTheme.accentLight,
          border: appTheme.accentBorder,
          marginBottom: "28px"
        }}>
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: "18px", fontWeight: "800", color: appTheme.accentColor }}>
              {programme.duration}
            </div>
            <div style={{ fontSize: "11px", color: appTheme.secondaryText, marginTop: "2px" }}>
              completed
            </div>
          </div>
          <div style={{
            width: "1px",
            background: appTheme.cardBorder.replace("1px solid ", ""),
            alignSelf: "stretch"
          }} />
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: "18px", fontWeight: "800", color: appTheme.accentColor }}>
              {programme.focus}
            </div>
            <div style={{ fontSize: "11px", color: appTheme.secondaryText, marginTop: "2px" }}>
              focus
            </div>
          </div>
        </div>

        {/* Buttons */}
        <div style={{
          display: "flex",
          flexDirection: "column",
          gap: "10px"
        }}>
          <button
            onClick={onChooseNew}
            style={{
              width: "100%",
              padding: "14px",
              borderRadius: "16px",
              border: appTheme.accentBorder,
              background: appTheme.accentColor,
              color: "#ffffff",
              fontSize: "15px",
              fontWeight: "700",
              cursor: "pointer",
              transition: "all 0.18s ease"
            }}
          >
            Choose New Programme
          </button>

          <button
            onClick={onBackToManual}
            style={{
              width: "100%",
              padding: "14px",
              borderRadius: "16px",
              border: appTheme.pillBorder,
              background: appTheme.pillBackground,
              color: appTheme.primaryText,
              fontSize: "15px",
              fontWeight: "600",
              cursor: "pointer",
              transition: "all 0.18s ease"
            }}
          >
            Back to Manual Mode
          </button>
        </div>
      </div>
    </div>
  );
}

export default ProgrammeSuccessModal;